import React from 'react'
import classnames from 'classnames'
import './fortnightly-toggle.css'

const ToggleInput = ({ name, value, onChange, checked, children }) => (
  <div className={
    classnames({
      'fortnightlyToggle--input': true,
      'fortnightlyToggle--input__clickable': !checked,
      'fortnightlyToggle--input__checked': checked,
    })
  }
  >
    <label htmlFor={name + value}>
      <input
        type="radio"
        name={name}
        id={name + value}
        value={value}
        checked={checked}
        onChange={() => checked ? null : onChange(value)}
      />
      {children}
    </label>
  </div>
)

const FortnightlyToggle = ({ onChange, selectedFreq }) => (
  <div className="fortnightlyToggle--wrapper">
    <ToggleInput
      name="fortnightly"
      value={'weekly'}
      checked={selectedFreq.weekly}
      onChange={onChange}
    >
      Weekly
    </ToggleInput>

    <ToggleInput
      name="fortnightly"
      value={'fortnightly'}
      checked={selectedFreq.fortnightly}
      onChange={onChange}
    >
      Fortnightly
    </ToggleInput>

    <ToggleInput
      name="frequency"
      value={'casual'}
      checked={selectedFreq.casual}
      onChange={onChange}
    >
      Casual
    </ToggleInput>
  </div>
)

export default FortnightlyToggle


// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/update-enrolment-schedule/form/fortnightly-toggle/index.jsx